export type SubfractionBand = "fine" | "medium" | "coarse";

const ORDER: SubfractionBand[] = ["fine", "medium", "coarse"];

export function subfractionWord(bands: Partial<Record<SubfractionBand, number>>): string | null {
  const present = ORDER.filter((band) => bands[band] != null);
  const total = present.reduce((sum, band) => sum + (bands[band] ?? 0), 0);
  if (total <= 0) return null;

  const share = (band: SubfractionBand) => ((bands[band] ?? 0) / total) * 100;
  const [largest, ...rest] = [...present].sort((a, b) => share(b) - share(a));
  const largestIndex = ORDER.indexOf(largest);
  const isAdjacent = (band: SubfractionBand) => Math.abs(ORDER.indexOf(band) - largestIndex) === 1;

  if (share(largest) >= 60) return largest;
  if (share(largest) < 40 || rest.length === 0) return null;

  const second = rest.find((band) => share(band) === share(rest[0]) && isAdjacent(band)) ?? rest[0];
  if (!isAdjacent(second)) return null;
  return ORDER.indexOf(second) < largestIndex ? `${second} to ${largest}` : `${largest} to ${second}`;
}
